export default __webpack_public_path__ + "static/media/cog.3bd8069c.png";